import { collection } from "firebase/firestore";

import { db } from "../firebase";
import { subscribeCollection } from "./helpers";
import { PropertyPortal } from "../../lib/types/propertyPortal";

export const subscribePortals = () => {
  return subscribeCollection<PropertyPortal>(collection(db, "property-portals"));
};
